export default [
    {
        path: "/malpractice/complaints",
        name: "complaints",
        meta: { title: "Complaints", authRequired: true },
        component: () => import("../views/investigations/cases.vue"),
    },
    {
        path: "/malpractice/new",
        name: "new-complaint",
        meta: { title: "New-Complaint", authRequired: true },
        component: () => import("../views/investigations/new-case.vue"),
    },
    {
        path: "/malpractice/requestsForInformation",
        name: "requestsForInformation",
        meta: { title: "Requests For Information", authRequired: true },
        component: () => import("../views/investigations/requestsForInformation.vue"),
    },
    {
        path: "/malpractice/view",
        name: "view-request",
        meta: { title: "View-Request-For-Information", authRequired: true },
        component: () => import("../views/investigations/view-request.vue"),
    }
]